module.exports = __webpack_public_path__ + "img/pulsating-dot.c003add4.gif";